__turbopack_context__.v({
  "className": "nhxSHq_className",
  "variable": "nhxSHq_variable",
});
